module.exports = __webpack_public_path__ + "assets/img/process-01.138cfa03.png";